import { SortArrows } from '@rio-cloud/rio-uikit';
import { getBudgetStatusLabel } from '../../../../../enums/budgetStatus';
import { BudgetRecipientEnum } from '../../../createAndEdit/types';
import { Budget, BudgetHistory } from '../../../types';
import ViewBudgetButton from '../ViewBudgetButton';
import { useBudgetNavigation } from '../../hooks/useBudgetNavigation';

interface IBudgetHistoryTableProps {
  history: BudgetHistory[];
  budgetId: string;
  onViewBudget: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  budget?: Budget;
  userProfile?: BudgetRecipientEnum | string;
}

interface IBudgetHistoryRowProps {
  historyItem: BudgetHistory;
  budgetId: string;
  onViewBudget?: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  budget?: Budget;
  userProfile?: BudgetRecipientEnum | string;
}

const BudgetHistoryRow = (props: IBudgetHistoryRowProps) => {
  const versionNumber = props.historyItem.version;
  const lastVersionNumber = props.budget?.lastVersionNumber;
  const budgetForNavigation: Budget = props.budget || {
    id: props.budgetId,
    consultantName: '',
    origin: '',
    recipient: '',
    user: '',
    version: props.historyItem.version,
    date: props.historyItem.versionDate,
    status: props.historyItem.status,
    lastVersionNumber,
  };

  const { handleBudgetClick } = useBudgetNavigation({
    budget: budgetForNavigation,
    userProfile: props.userProfile,
    onViewBudget: props.onViewBudget,
    onEditBudget: props.onEditBudget,
    versionNumber,
  });

  return (
    <tr className="hover:bg-gray-50 cursor-default">
      <td>{props.historyItem.profile}</td>
      <td>{props.historyItem.user}</td>
      <td>
        <div className="flex items-center gap-2 flex-wrap">
          {props.historyItem.budgetUser && (
            <span className="text-size-14 whitespace-nowrap">
              {props.historyItem.budgetUser}
            </span>
          )}
          {props.onViewBudget && <ViewBudgetButton onClick={handleBudgetClick} />}
        </div>
      </td>
      <td>{props.historyItem.version}</td>
      <td>{props.historyItem.versionDate}</td>
      <td>
        <span>{getBudgetStatusLabel(props.historyItem.status)}</span>
      </td>
    </tr>
  );
};

const BudgetHistoryTable = (props: IBudgetHistoryTableProps) => {
  return (
    <table className="table table-column-overflow-hidden table-bordered table-head-filled">
      <thead>
        <tr>
          <th className="user-select-none sort-column">
            <span>
              <SortArrows />
              <span>Perfil</span>
            </span>
          </th>
          <th className="user-select-none sort-column">
            <span>
              <SortArrows />
              <span>Usuário</span>
            </span>
          </th>
          <th className="user-select-none sort-column">
            <span>
              <SortArrows />
              <span>Ver orçamento</span>
            </span>
          </th>
          <th className="user-select-none sort-column">
            <span>
              <SortArrows />
              <span>Versão</span>
            </span>
          </th>
          <th className="user-select-none sort-column">
            <span>
              <SortArrows />
              <span>Data da versão</span>
            </span>
          </th>
          <th className="user-select-none sort-column">
            <span>
              <SortArrows />
              <span>Status</span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {props.history.map((historyItem) => (
          <BudgetHistoryRow
            key={historyItem.id}
            historyItem={historyItem}
            budgetId={props.budgetId}
            onViewBudget={props.onViewBudget}
            onEditBudget={props.onEditBudget}
            budget={props.budget}
            userProfile={props.userProfile}
          />
        ))}
      </tbody>
    </table>
  );
};

export default BudgetHistoryTable;

